import { api } from "@/lib/api";
import type { ApiResponse } from "@learn-me/types";

export interface ActivityItem {
  id: string;
  type: string;
  entityType?: string;
  entityId?: string;
  metadata?: {
    title?: string;
    score?: number;
    passingScore?: number;
    courseTitle?: string;
    courseSlug?: string;
    chapterTitle?: string;
    badgeName?: string;
    badgeIcon?: string;
  };
  createdAt: string;
}

export interface ActivityStats {
  chapter_completed?: number;
  quiz_passed?: number;
  quiz_failed?: number;
  badge_earned?: number;
  course_completed?: number;
  enrollment?: number;
  course_started?: number;
}

export const activityApi = {
  async getRecentActivity(limit = 10, offset = 0): Promise<ActivityItem[]> {
    const response = await api.get<ApiResponse<ActivityItem[]>>(
      `/activity?limit=${limit}&offset=${offset}`,
    );
    return response.data.data!;
  },

  async getStats(): Promise<ActivityStats> {
    const response =
      await api.get<ApiResponse<ActivityStats>>("/activity/stats");
    return response.data.data!;
  },
};
